import { useEffect, useState } from "react";
import { Input, Button, Row, Col, Card, CardBody } from "reactstrap";
import { API } from "../../../api/API";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import TreeModel from "./AttendanceTable/TreeModel";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import FeatherIconCom from "../../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Label, FormGroup } from 'reactstrap';
import MonthDropdown from "../../CommonCompo/MonthDropdown";
import Loader from "../../../Layout/Loader";

type AttendanceMeProps = {
    employeeIdProp?: number;
    tdate?: string;
    positionId?: number;
};
export default function AttendanceMe({ employeeIdProp, tdate, positionId }: AttendanceMeProps) {
    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const [attendanceData, setAttendanceData] = useState<any[]>([]);
    const [kpiData, setKpiData] = useState<any>(null);

    const [displayedData, setDisplayedData] = useState<any[]>([]);
    const [searchText, setSearchText] = useState('');
    const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
    const [loading, setLoading] = useState(true);
    const [selectedMonth, setSelectedMonth] = useState<string>('');

    // useEffect(() => {
    //     fetchAttendanceData();
    // }, [selectedIds]);
    useEffect(() => {
        fetchAttendanceData();
    }, [tdate, employeeIdProp, selectedMonth]); // optional dependencies

    useEffect(() => {
        fetchKpiData();
    }, [tdate, selectedMonth]); // optional dependencies

    const fetchAttendanceData = async () => {
        if (!serverUrl || !APP_TOKEN) return;
        setLoading(true);

        const urlAttendance = `${serverUrl}${API.getAttendanceSummary}`;
        let empId = employeeIdProp || localStorage.getItem("employeeId") || localStorage.getItem("employee_id") || localStorage.getItem("empId");
        
        const params: any = {};
        if (empId && empId !== 'null' && empId !== 'undefined') {
            params.employee_id = empId;
        }
        if (selectedMonth) {
            params.moye = selectedMonth;
        }

        const { status, data } = await getData(urlAttendance, true, params);

        if (status === 200 && data?.data) {
            let list: any[] = [];
            if (Array.isArray(data.data)) {
                list = data.data;
            } else if (typeof data.data === 'object') {
                list = Object.values(data.data);
            }
            setAttendanceData(list);
            setDisplayedData(list);
        } else {
            setAttendanceData([]);
            setDisplayedData([]);
        }

        setLoading(false);
    };

    const fetchKpiData = async () => {
        if (!serverUrl || !APP_TOKEN) return;
        setLoading(true);

        const urlKpis = `${serverUrl}${API.getActivityKpis}`;
        const moye = tdate ? `${tdate.split('-')[1]}-${tdate.split('-')[0]}` : '';
console.log(positionId, 'positionId', selectedMonth, 'selectedMonth');

        const { status, data } = await getData(urlKpis, true, {
            position_id: `${positionId}`,
            moye: selectedMonth,
            // type and rollup optional
        });
        // console.log(data, selectedMonth, 'datakpis');

        if (status === 200 && data?.data) {
            setKpiData(data.data);
        } else {
            setKpiData(null);
        }

        setLoading(false);
    };



    useEffect(() => {
        const lower = searchText.toLowerCase();
        const filtered = attendanceData.filter((item) =>
            Object.values(item).some(val =>
                String(val).toLowerCase().includes(lower)
            )
        );
        setDisplayedData(filtered);
    }, [searchText, attendanceData]);

    const handleExportToExcel = () => {
        if (displayedData.length === 0) return;
        const worksheet = XLSX.utils.json_to_sheet(displayedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance Report');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Attendance_${new Date().toISOString().split("T")[0]}.xlsx`);
    };
    // console.log(displayedData, '===========================');

    const keys = displayedData.length > 0 ? Object.keys(displayedData[0]) : [];
    const headData = [
        { id: '1', head: 'Attendance Date', key: 'AttendanceDate', sortKey: 'AttendanceDate' },
        { id: '2', head: 'Start Time', key: 'StartTime', sortKey: 'StartTime' },
        { id: '3', head: 'Start Town Name', key: 'StartTownName', sortKey: 'StartTownName' },
        { id: '4', head: 'End Time', key: 'EndTime', sortKey: 'EndTime' },
        { id: '5', head: 'End Town Name', key: 'EndTownName', sortKey: 'EndTownName' },
        { id: '6', head: 'Shift Hours', key: 'ShiftMins', sortKey: 'ShiftMins' },
        { id: '7', head: 'Status', key: 'Status', sortKey: 'Status' },
        { id: '8', head: 'Remark', key: 'Remark', sortKey: 'Remark' },
        { id: '9', head: 'Expense ID', key: 'ExpenseId', sortKey: 'ExpenseId' },
        { id: '10', head: 'Expense Generated', key: 'ExpenseGenerated', sortKey: 'ExpenseGenerated' },
        { id: '11', head: 'Expense Remark', key: 'ExpenseRemark', sortKey: 'ExpenseRemark' },
        { id: '12', head: 'Expense Final Amt', key: 'Expenses.ExpenseFinalAmt', sortKey: 'Expenses.ExpenseFinalAmt' },
        { id: '13', head: 'Trip Type', key: 'Expenses.TripType', sortKey: 'Expenses.TripType' },
        { id: '14', head: 'Can Do Verify', key: 'canDoVerify', sortKey: 'canDoVerify' },
        { id: '15', head: 'Travelled Distance', key: 'TravelledDistance', sortKey: 'TravelledDistance' },
        { id: '16', head: 'eDetailing Distance', key: 'eDetailingDistance', sortKey: 'eDetailingDistance' },
        { id: '17', head: 'Productive Calls', key: 'productive_calls', sortKey: 'productive_calls' },
        { id: '18', head: 'Action', key: 'Action', sortKey: null },
    ];

    // Helper functions for report URLs
    const formatShiftHours = (shiftMinsRaw: any) => {
        if (shiftMinsRaw === undefined || shiftMinsRaw === null || shiftMinsRaw === '') {
            return '-';
        }
        const totalMins = parseInt(String(shiftMinsRaw), 10);
        if (isNaN(totalMins) || totalMins < 0) {
            return '-';
        }
        const hours = Math.floor(totalMins / 60);
        const minutes = totalMins % 60;
        return `${hours}h ${minutes}m`;
    };

    const openReportPage = (reportPath: string, extraParams: Record<string, string> = {}) => {
        if (!serverUrl) return;
        let empId = employeeIdProp || localStorage.getItem("employeeId") || localStorage.getItem("employee_id") || localStorage.getItem("empId") || "";
        const queryParams = new URLSearchParams({
            apptoken: APP_TOKEN || "",
            ...extraParams
        });
        if (empId) queryParams.set("employee_id", String(empId));

        const fullUrl = `${serverUrl}${reportPath}?${queryParams.toString()}`;
        window.open(fullUrl, '_blank');
    };

    const handleOpenDarReport = (dateStr: string) => {
        openReportPage("report/DarReport", { date: dateStr });
    };

    const handleOpenDvpReport = () => {
        openReportPage("report/DvpReport", { Moye: selectedMonth });
    };

    const handleOpenSgpiReport = () => {
        openReportPage("report/sgpiBrnadWiseDistribution", { month: selectedMonth });
    };

    const handleOpenMasReport = () => {
        openReportPage("report/MasReport", { month: selectedMonth });
    };

    const handleOpenMtpDeviationReport = () => {
        openReportPage("report/MtpDeviationReport", { date: tdate || new Date().toISOString().split("T")[0] });
    };

    // inside your component
    const [modalOpen, setModalOpen] = useState(false);
    const [editRow, setEditRow] = useState<any>(null);

    const openEditModal = (row: any) => {
        setEditRow(row);
        setModalOpen(true);
    };

    const closeEditModal = () => {
        setModalOpen(false);
        setEditRow(null);
    };

    // update function if needed
    const handleChange = (field: string, value: any) => {
        setEditRow((prev: any) => ({ ...prev, [field]: value }));
    };


    return (
        <Card className="p-3">
            <div className='d-flex justify-content-between align-items-center pt-2 pb-2 flex-wrap gap-2'>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Col xs="auto">
                        <Input
                            type="text"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Search here"
                        />
                    </Col>
                    <button className="btn btn-sm btn-primary d-flex align-items-center" onClick={handleExportToExcel}>
                        <FeatherIconCom iconName="Download" size={14} className="text-light" />
                        <span className="px-2" style={{ fontSize: 14 }}>Export</span>
                    </button>
                </div>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <button className="btn btn-sm btn-outline-info" onClick={handleOpenDvpReport}>
                        DVP Report
                    </button>
                    <button className="btn btn-sm btn-outline-secondary" onClick={handleOpenSgpiReport}>
                        SGPI Report
                    </button>
                    <button className="btn btn-sm btn-outline-success" onClick={handleOpenMasReport}>
                        MAS Report
                    </button>
                    <button className="btn btn-sm btn-outline-warning" onClick={handleOpenMtpDeviationReport}>
                        MTP Deviation
                    </button>
                    <MonthDropdown onChange={(value) => setSelectedMonth(value)} />
                </div>
            </div>

            {!kpiData ? (
                <div className="text-center p-4"> KPI Data not available</div>
            ) : (
                <Row>

                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Total Calls Done
                                        </h6>
                                        <h3>{kpiData?.TotalCalls || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Call Average
                                        </h6>
                                        <h3>
                                            {kpiData?.AttendanceDays && kpiData.AttendanceDays !== 0
                                                ? (kpiData.TotalCalls / kpiData.AttendanceDays).toFixed(2)
                                                : '0.00'}
                                        </h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Visit Frequency
                                        </h6>
                                        <h3>{kpiData?.VfCoverage || 0} / {kpiData?.TotalVfq || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            {kpiData?.DefaultOutletName || 'Outlet'} Compliance
                                        </h6>
                                        <h3>{kpiData?.OutletsCovered || 0} / {kpiData?.TotalOutlets || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                     <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Total Travelled KM
                                        </h6>
                                        <h3>{kpiData?.TotalTravelledKm || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>

            )}

            {loading ? (
                <Loader height="250px" />
            ) : (
                <CommonTableNew
                    caption=""
                    headData={headData}
                    data={displayedData}
                    initialRows={50}
                    renderRow={(row: any, rowIndex: number) => {
                        const shiftHours = formatShiftHours(row.ShiftMins);
                        const expFinalAmt = row["Expenses.ExpenseFinalAmt"] ?? row.ExpenseFinalAmt ?? '-';
                        const tripType = row["Expenses.TripType"] ?? row.TripType ?? '-';
                        const attDate = row.AttendanceDate || '';

                        return (
                            <tr key={rowIndex}>
                                <td>{attDate || '-'}</td>
                                <td>{row.StartTime || '-'}</td>
                                <td>{row.StartTownName || '-'}</td>
                                <td>{row.EndTime || '-'}</td>
                                <td>{row.EndTownName || '-'}</td>
                                <td>{shiftHours}</td>
                                <td>{row.Status !== undefined && row.Status !== null ? String(row.Status) : '-'}</td>
                                <td>{row.Remark || '-'}</td>
                                <td>{row.ExpenseId !== undefined && row.ExpenseId !== null && row.ExpenseId !== '' ? String(row.ExpenseId) : '-'}</td>
                                <td>{row.ExpenseGenerated ? 'Yes' : 'No'}</td>
                                <td>{row.ExpenseRemark || '-'}</td>
                                <td>{expFinalAmt}</td>
                                <td>{tripType}</td>
                                <td>{row.canDoVerify ? 'Yes' : 'No'}</td>
                                <td>{row.TravelledDistance || '-'}</td>
                                <td>{row.eDetailingDistance || '-'}</td>
                                <td>{row.productive_calls || '-'}</td>
                                <td>
                                    {attDate ? (
                                        <button
                                            className="btn btn-xs btn-outline-primary py-1 px-2 fw-semibold"
                                            style={{ fontSize: '0.75rem' }}
                                            onClick={() => handleOpenDarReport(attDate)}
                                        >
                                            DAR
                                        </button>
                                    ) : '-'}
                                </td>
                            </tr>
                        );
                    }}
                />

            )}
            <Modal isOpen={modalOpen} toggle={closeEditModal}>
                <ModalHeader toggle={closeEditModal}>Edit Attendance Data</ModalHeader>
                <ModalBody>
                    {editRow &&
                        Object.entries(editRow).map(([key, value]) => {
                            let inputType: "text" | "number" = "text";
                            if (typeof value === "number") inputType = "number";

                            // Boolean → render select box
                            if (typeof value === "boolean") {
                                return (
                                    <FormGroup key={key}>
                                        <Label>{key}</Label>
                                        <Input
                                            type="select"
                                            value={value ? "Yes" : "No"}
                                            onChange={(e) =>
                                                handleChange(key, e.target.value === "Yes")
                                            }
                                        >
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </FormGroup>
                                );
                            }
                            // String/Number → render text/number input
                            return (
                                <FormGroup key={key}>
                                    <Label>{key}</Label>
                                    <Input
                                        type={inputType}
                                        value={value !== null && value !== undefined ? String(value) : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                key,
                                                inputType === "number"
                                                    ? Number(e.target.value)
                                                    : e.target.value
                                            )
                                        }
                                    />
                                </FormGroup>
                            );
                        })}

                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={() => {
                        // console.log('✅ Updated Row:', editRow);
                        closeEditModal();
                    }}>Save</Button>
                    <Button color="secondary" onClick={closeEditModal}>Cancel</Button>
                </ModalFooter>
            </Modal>


        </Card>
    );
}
